<section id="intro-app-development" class="section-bg-dark">
    <div class="container-fluid">
        <div class="row">
            <div class="col-xs-12 pl-5">
                <h2 class="text-white">DESARROLLO COMERCIAL</h2>
            </div>
        </div>
    </div>
</section>

<section id="mobile">
    <div class="container">

        <div class="row">
            <div class="col-sm-12 col-xs-12">
                <p class="font-medium">
                    Impulsamos el crecimiento de las empresas mediante estrategias comerciales orientadas a resultados,
                    optimización de procesos de venta y la incorporación de herramientas que mejoran la captación,
                    conversión y fidelización de clientes.
                </p>
            </div>
        </div>

        <div class="row justify-mobile">
            <div class="col-sm-4 col-xs-12 text-right">
                <div class="row">
                    <div class="col-12 orden3">
                        @for (section of firstThreeSections; track section) {
                        <div class="row apps3">
                            <div class="col-9 col-xs-12">
                                <h3 class="icon-title">{{ section.title }}</h3>
                            </div>

                            <div class="first-icon icons_standar icons_blue col-3 col-xs-hidden">
                                <img src="{{ section.icon }}" alt="{{ section.title }}" class="filter-teal">
                            </div>

                            <div class="col-12">
                                <p> {{ section.description }}</p>
                            </div>
                            <div class="second-icon icons_standar icons_blue col-3 col-xs-hidden">
                                <img src="{{ section.icon }}" alt="{{ section.title }}" class="filter-teal">
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="col-sm-4 col-xs-12 img-completa img-responsive">
                <img src="assets/img/mobile-zeeker.png" alt="Desarrollo Móvil">
            </div>
            <div class="col-sm-4 col-xs-12 text-left">
                <div class="row">
                    <div class="col-12 orden3">
                        @for (section of lastThreeSections; track section) {
                        <div class="row apps3">
                            <div class="first-icon icons_standar icons_blue col-3 col-xs-hidden">
                                <img src="{{ section.icon }}" alt="{{ section.title }}" class="filter-teal">
                            </div>

                            <div class="col-9 col-xs-12">
                                <h3 class="icon-title">{{ section.title }}</h3>
                            </div>

                            <div class="col-12">
                                <p> {{ section.description }}</p>
                            </div>
                            <div class="second-icon icons_standar icons_blue col-3 col-xs-hidden">
                                <img src="{{ section.icon }}" alt="{{ section.title }}" class="filter-teal">
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<section id="tecnologies">
    <div class="container">
        <div class="row">
            <div class="col-xs-12 w-100 text-center">
                <h2>Herramientas que utilizamos</h2>
            </div>
        </div>
        <div class="carousel slide carousel-multi-item" data-ride="carousel" data-interval="1500">
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <div class="row logos">
                        @for (carousel of carousels; track carousel) {
                        <div class="col-xs-3 col-md-3 text-center">
                            <img src="{{ carousel.img }}" alt="icon" class="icons_standar">
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>
<section id="value">
    <div class="container">
        <div class="row">
            <div class="col-xs-12 w-100 text-center">
                <h2>Valor de nuestro desarrollo comercial</h2>
                <p> Nuestra experiencia en consultoría y operaciones comerciales nos permite identificar oportunidades,
                    optimizar procesos y construir una estrategia de ventas eficiente, realista y alineada a los
                    objetivos del negocio.</p>
            </div>
        </div>
        <div class="row">
            @for (value of values; track value) {
                <div class="col-xs-12 col-sm-4 text-center">

                <h5>{{ value.text }}</h5>
                <div class="first-icon icons_standar icons_blue col-3">
                    <img src="{{ value.icon.src }}" alt="{{ value.icon.alt }}" class="w-100 filter-teal">
                </div>
            </div>
            }
        </div>
    </div>
</section>